import * as S from './styles'

type GuideTourStepCardFooterProps = Readonly<{
  continueLabel: string
  isFirstStep: boolean
  isSummaryOnly: boolean
  blockedTargetInteractionFeedbackKey: number | undefined
  onNext: () => void
  onPrev: () => void
}>

export function GuideTourStepCardFooter({
  continueLabel,
  isFirstStep,
  isSummaryOnly,
  blockedTargetInteractionFeedbackKey,
  onNext,
  onPrev,
}: GuideTourStepCardFooterProps) {
  return (
    <S.Footer>
      <S.Actions>
        {!isSummaryOnly && !isFirstStep ? (
          <S.SecondaryButton type="button" onClick={onPrev}>
            Voltar
          </S.SecondaryButton>
        ) : null}
        <S.PrimaryButton
          type="button"
          onClick={onNext}
          $pulseTrigger={blockedTargetInteractionFeedbackKey}
        >
          {continueLabel}
        </S.PrimaryButton>
      </S.Actions>
    </S.Footer>
  )
}
